export const styles = theme => ({
  container: {
    width: 'initial',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  }
})



// WEBPACK FOOTER //
// ./src/components/Drivers/components/CreateDriverForm/styles.js